import MarqueeLib from "react-fast-marquee";
import { useContent } from "@/context/ContentContext";
import { Spark } from "@/components/Doodles";

const Marquee = ({ invert = false }) => {
    const { t } = useContent();
    const text = t("global.marquee", "A GATHERING PLACE FOR WEIRDOS ✳ COMING SOON TO RICHLAND HILLS ✳ ");
    return (
        <div
            data-testid="editorial-marquee"
            className={`border-y-2 border-ink py-3 ${invert ? "bg-forest text-cream" : "bg-mustard text-ink"}`}
        >
            <MarqueeLib speed={26} gradient={false} aria-hidden="true">
                <span className="mx-2 inline-flex items-center gap-4 whitespace-nowrap font-display text-2xl tracking-[0.18em]">
                    {(text + text).split("✳").map((chunk, i) => (
                        <span key={i} className="inline-flex items-center gap-4">
                            <span>{chunk.trim()}</span>
                            <Spark className="h-4 w-4 shrink-0" />
                        </span>
                    ))}
                </span>
            </MarqueeLib>
        </div>
    );
};

export default Marquee;
